import React, { useEffect, useState } from 'react';
import '../../css/hearts.css';

interface HeartProps {
  delay: number;
  duration: number;
  size: number;
  left: number;
}

const Heart: React.FC<HeartProps> = ({ delay, duration, size, left }) => {
  return (
    <div
      className="heart"
      style={{
        left: `${left}%`,
        animationDelay: `${delay}s`,
        animationDuration: `${duration}s`,
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      <svg viewBox="0 0 40 40" fill="#fd356e">
        <path d="M20 35.8c-0.6 0-1.2-0.2-1.6-0.5l-0.8-0.7C11.1 29.2 4 22.9 4 16c0-5.5 4.5-10 10-10 2.9 0 5.7 1.2 7.6 3.4l0.4 0.4 0.4-0.4C24.3 7.2 27.1 6 30 6c5.5 0 10 4.5 10 10 0 6.9-7.1 13.2-13.6 18.6l-0.8 0.7c-0.4 0.3-1 0.5-1.6 0.5z" />
      </svg>
    </div>
  );
};

export default function AnimatedHearts() {
  const [hearts, setHearts] = useState<HeartProps[]>([]);

  useEffect(() => {
    const heartConfigs: HeartProps[] = Array.from({ length: 15 }, () => ({
      delay: Math.random() * 5,
      duration: 3 + Math.random() * 6,
      size: 10 + Math.random() * 30,
      left: 15 + Math.random() * 50,
    }));

    setHearts(heartConfigs);
  }, []);

  return (
    <div className="pointer-events-none absolute inset-0 z-10 mx-auto overflow-hidden">
      {hearts.map((config, index) => (
        <Heart key={index} {...config} />
      ))}
    </div>
  );
}
